import wiredWirelessNetwork from "public/network-services/wired-wireless-network.png";

export const INTRO_CONSTANTS = {
  title: "Wired & Wireless Connectivity, Engineered by OneMind",
  description: [
    "Reliable, high-performance networking starts with the right foundation. OneMind delivers fully managed wired and wireless solutions that ensure seamless, secure, and scalable connectivity across your entire environment.",
    "Wired networks provide ultra-fast, stable connections through physical cabling—ideal for high-throughput and security-sensitive operations.",
    "Wireless networks offer mobility and flexibility using enterprise-grade Wi-Fi, giving users secure access without the physical limitations.",
  ],
  conclusion:
    "OneMind makes it simple to connect, scale, and manage—no matter how your teams work. ",
  image: wiredWirelessNetwork,
  imageHeight: "360px",
};
